import React from 'react'
import {Link} from 'react-router-dom'
import {GoDotFill} from 'react-icons/go'
import useTranslate from 'modules/local/useTranslate'

// Callout mô tả PHẠM VI dữ liệu của 1 tab trong danh sách tổng hợp (VD: tab "Nhóm & Đơn vị"/"Lớp
// học" ở Lịch sinh hoạt, tab "Cộng đoàn"/"Khóa học" ở Thông báo) - dùng chung để 2 khu vực nhất
// quán 1 format: mô tả ngắn + (tuỳ chọn) 1 dòng hướng dẫn trỏ đúng nơi có quyền tạo/quản lý, tránh
// user tìm nút tạo mãi không thấy. guideKey/linkTo/linkLabel bỏ trống khi KHÔNG có nơi nào trong
// Workspace để trỏ tới (VD: thông báo Lớp học hiện chỉ tạo được từ app Giáo viên) - lúc đó chỉ hiện
// dòng mô tả, không bịa đường link.
export const WorkspaceScopeGuide = ({description, guideKey, linkTo, linkLabel}) => {
    const t = useTranslate()
    return (
        <div className="mb-3 p-3 border border-blue-300 bg-blue-50 rounded-xl text-xs flex flex-col gap-1">
            <span className="text-blue-700 tracking-wider">{t(description)}</span>
            {guideKey && (
                <div className="space-x-1 text-gray-700 tracking-wider">
                    <GoDotFill size={10} className="flex-shrink-0"/>
                    <span>
                        {t(guideKey, {
                            action: (
                                <Link to={linkTo} className="font-bold text-blue-700 no-underline">
                                    {t(linkLabel)}
                                </Link>
                            ),
                        })}
                    </span>
                </div>
            )}
        </div>
    )
}

export default WorkspaceScopeGuide
